import { render, staticRenderFns } from "./UploadVideo-ai.vue?vue&type=template&id=d06a54b0&scoped=true"
import script from "./UploadVideo-ai.vue?vue&type=script&lang=ts"
export * from "./UploadVideo-ai.vue?vue&type=script&lang=ts"
import style0 from "./UploadVideo-ai.vue?vue&type=style&index=0&id=d06a54b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d06a54b0",
  null
  
)

export default component.exports